import { Component, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ModalButton {
  textButton: string;
  fill?: 'solid' | 'outline';
  action?: () => void;
}

export interface ModalOptions {
  title?: string;
  titleText?: string;
  message?: string;
  subtitleText?: string;
  type?: 'error' | 'success' | 'warning' | 'info';
  buttonText?: string;
  showCloseButton?: boolean;
  autoClose?: boolean;
  autoCloseDelay?: number;
  width?: string;
  maxWidth?: string;
  panelClass?: string;
  backdropClass?: string;
  disableClose?: boolean;
  imagemUrl?: string;
  listButtons?: ModalButton[];
}

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  options: ModalOptions;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ModalOptions,
    private dialogRef: MatDialogRef<ModalComponent>
  ) {
    this.options = { ...this.getDefaultOptions(), ...data };
    
    // Auto-close se configurado
    if (this.options.autoClose && this.options.autoCloseDelay) {
      setTimeout(() => {
        this.close();
      }, this.options.autoCloseDelay);
    }
  }

  private getDefaultOptions(): ModalOptions {
    return {
      message: '',
      type: 'info',
      buttonText: 'OK',
      showCloseButton: true,
      autoClose: false,
      autoCloseDelay: 5000
    };
  }

  get type(): string {
    return this.options.type || 'info';
  }

  onButtonClick(button: ModalButton): void {
    if (button.action) {
      button.action();
    }
    this.close();
  }

  getDefaultTitle(): string {
    switch (this.type) {
      case 'error': return 'Erro';
      case 'success': return 'Sucesso';
      case 'warning': return 'Atenção';
      case 'info': return 'Informação';
      default: return 'Informação';
    }
  }

  getIcon(): string {
    switch (this.type) {
      case 'error': return 'error';
      case 'success': return 'check_circle';
      case 'warning': return 'warning';
      case 'info': return 'info';
      default: return 'info';
    }
  }

  getIconClass(): string {
    return `modal-header__icon--${this.type}`;
  }

  getModalTypeClass(): string {
    return `modal-container--${this.type}`;
  }

  getButtonClass(): string {
    return `modal-footer__button--${this.type}`;
  }

  close(): void {
    this.dialogRef.close();
  }
}
